<template>
    <Container class="px-[18px]">
        <div class="flex space-x-[15px] items-center justify-between">
            <div>
                <h4 class="font-[600] md:font-[700] text-[20px] md:text-[32px] mb-[18px] md:mb-[30px]">
                    {{ heading }}
                </h4>

                <p v-if="body" class="text-[14px] md:text-[20px] mb-[20px]">{{ body }}</p>

                <div v-for="(link, index) in links" :key="index">
                    <div class="flex space-x-[12px] items-center mb-[10px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <circle cx="8.5" cy="8.5" r="8.5" fill="#F7DBA6" />
                        </svg>
                        <a class="text-[16px] md:text-[20px] text-[#1D4179] underline underline-offset-2 font-[500]"
                            :href="link.url">
                            {{ link.text }}
                        </a>
                    </div>
                </div>
            </div>

            <div class="hidden md:block">
                <a :href="imageLink">
                    <img :src="imageSrc" :width="imageWidth" alt=""/>
                </a>
            </div>
        </div>
    </Container>
</template>

<script>
import Container from '../../../Layouts/Container.vue'
export default {
    components: {
        Container
    },
    props: {
        heading: {
            type: String,
            default: "Our Supporting Organizations",
        },
        body: {
            type: String,
            default: "",

        },
        imageSrc: {
            type: String,
            default: '/img/cc-sh-supporting-org.png'
        },
        imageWidth: {
            type: String,
            default: 252
        },
        imageLink: {
            type: String,
            default: '',
        },
        links: {
            type: Array,
            default: {
                links: [
                    {
                        text: '',
                        url: ''
                    }
                ]

            }
        },
    }
}
</script>
